import { faFilter } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC, useCallback, useEffect, useRef, useState } from "react";
import { Unity } from "../../../../domain/unity";
import { isEmpty } from "lodash";
import { isNotBlank } from "../../../../util/validation";
import {
  Button,
  Form,
  IconButton,
  InputGroup,
  Modal,
  Schema,
  SelectPicker,
} from "rsuite";
import { useNavigate } from "react-router-dom";
import { Search } from "@rsuite/icons";
import { ok } from "assert";

// Definir las opciones de ordenación (basado en tu ejemplo)
const OrderByOptions = [
  { value: "id", label: "ID" },
  { value: "label", label: "Nombre" },
];

const OrderOptions = [
  { value: "asc", label: "Ascendente" },
  { value: "desc", label: "Descendente" },
];

type Props = {
  onOrder?: (sortBy: string, order: string) => void;
  results: Unity[] | null;
  loading?: boolean;
  onClose?: () => void;
  okButtonDisabled?: boolean;
  okButtonLoading?: boolean;
};

export const OrderUnityModal: FC<Props> = ({
  onOrder,
  onClose,
  okButtonDisabled,
  okButtonLoading,
}) => {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const ghostGenerateButtonRef = useRef<HTMLButtonElement>(null);
  const [keyword, setKeyword] = useState("");
  const [sortBy, setSortBy] = useState<
    "id" | "label" | "ownerUid" | "typeOfDay"
  >("id"); // Esto se ajusta según las opciones
  const [order, setOrder] = useState<"asc" | "desc">("asc"); // Tipo de orden

  useEffect(() => {
    if (keyword.length >= 2 && onOrder && !isEmpty(keyword)) {
      clearTimeout(timeoutRef.current!);
      timeoutRef.current = setTimeout(() => {
        onOrder(sortBy, order); // pasamos el criterio de orden y el tipo de orden
      }, 1000);
    }
  }, [keyword, sortBy, order, onOrder]);

  return (
    <Modal open={true} onClose={onClose} size="md">
      <Modal.Header>
        <Modal.Title>Ordenar Unidades</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="flex flex-col gap-2 w-full h-fit">
          <Form
            onSubmit={(proceed, e) => {
              e.preventDefault();
              if (proceed && onOrder) onOrder(sortBy, order); // Ejecutamos el orden seleccionado
            }}
            fluid
            model={Schema.Model({
              order: Schema.Types.StringType()
                .isRequired("Debe ingresar al menos 2 caracteres.")
                .minLength(2, "Debe ingresar al menos 2 caracteres.")
                .addRule(isNotBlank(1), "El campo no puede estar vacío."),
            })}
          >
            <Form.Group>
              <SelectPicker
                data={OrderByOptions}
                value={sortBy}
                onChange={(value) => {
                  if (value !== null)
                    setSortBy(
                      value as "id" | "label" | "ownerUid" | "typeOfDay"
                    );
                }}
                placeholder="Ordenar por"
                style={{ width: "100%" }}
                cleanable={false}
              />
            </Form.Group>

            <Form.Group>
              <SelectPicker
                data={OrderOptions}
                value={order}
                onChange={(value) => {
                  if (value !== null) setOrder(value as "asc" | "desc");
                }}
                placeholder="Orden"
                style={{ width: "100%" }}
                cleanable={false}
              />
            </Form.Group>
          </Form>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onClose}>Cancelar</Button>
        <IconButton
          loading={okButtonLoading}
          disabled={okButtonDisabled}
          appearance="primary"
          icon={<Search />}
          onClick={() => {
            ghostGenerateButtonRef.current?.click();
          }}
        >
          Buscar
        </IconButton>
      </Modal.Footer>
    </Modal>
  );
};
